export default __webpack_public_path__ + "static/media/project-aditya-birla.c3f50c97.png";